export default function EmotionalBanner() {
  return (
    <section className="py-16 md:py-20" style={{ background: 'linear-gradient(135deg, #534AB7 0%, #3C3489 100%)' }}>
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        <i className="ri-heart-fill text-[#AFA9EC] text-3xl mb-5 block"></i>
        <p className="font-title text-2xl md:text-4xl text-white leading-relaxed font-light italic max-w-3xl mx-auto">
          "No se trata solo de resolver un servicio. Se trata de darle tranquilidad a quienes amas."
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-6 md:gap-10">
          {[
            { icon: 'ri-shield-check-line', text: 'Accesible desde \$289/mes' },
            { icon: 'ri-settings-3-line', text: 'Flexible y adaptable' },
            { icon: 'ri-group-2-line', text: 'Plan Basico familiar' },
          ].map((item) => (
            <div key={item.text} className="flex items-center gap-2">
              <i className={`${item.icon} text-[#AFA9EC] text-base`}></i>
              <span className="text-white/75 text-sm font-light">{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
